import { render, staticRenderFns } from "./Movimentacao.vue?vue&type=template&id=115ef139&scoped=true"
import script from "./Movimentacao.vue?vue&type=script&lang=js"
export * from "./Movimentacao.vue?vue&type=script&lang=js"
import style0 from "./Movimentacao.vue?vue&type=style&index=0&id=115ef139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ef139",
  null
  
)

export default component.exports